import * as React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {Async} from '../reusableComponents/Async';
import {BasePage} from '../reusableComponents/BasePage';
import {Icon} from '../reusableComponents/Icon';
import {ListPage} from '../reusableComponents/ListPage';
import {Loader} from '../reusableComponents/Loader/Loader';
import {ListItem} from './ListItems';
import './organization.scss';
import {OrgModel} from '../../model/OrgModel';
import {getAllOrg} from '../../services/organizationService';

export interface IOrgListPageProps {
    instances: OrgModel[];
    history: IHistory;
}

export class OrgListPageImpl extends React.PureComponent<IOrgListPageProps, {}> {
    constructor(props: IOrgListPageProps) {
        super(props);
    }

    public promise = async () => {
        await getAllOrg();
    }

    public renderOrgList = () => {
        // @ts-ignore
        return <ListPage
            instances={this.props.instances as any[]}
            listItemComponent={ListItem}
            searchBy={['Name', 'DateCreated', 'Edit', 'Active']}
            pageHeadings={['Name', 'Created On', 'Edit', 'Status']}
            promise={this.promise}
            emptyListMessage="No Organizations Available"
            cols={[5, 3, 2, 2]}
            chartTitle = "OrganizationsList"
        />;
    }

    public render() {
        return <BasePage title="Organizations" className="list-page-with-edit-delete" icon="building">
            <Async
                identifier="OrgListPage"
                promise={this.promise}
                loader={<Loader type="async"/>}
                content={this.renderOrgList()}
                error={<Loader type="async"/>}
            />
            <div className="options-container">
                <div className="add-new" onClick={() => this.props.history.push('/org/create')}>
                    <Icon icon="plus"/>
                    &nbsp;
                    Add Organization
                </div>
            </div>
        </BasePage>;
    }
}

function mapStateToProps() {
    const orgList = OrgModel.list();
    return {
        instances: orgList
    };
}

export const OrgListPage = withRouter(connect<{}, {}, IOrgListPageProps>(mapStateToProps)(OrgListPageImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Organization/OrgListPage.tsx